@if (intervals?.length) {
    <div class="list list-card row calendar-list">
        @if (isCarouselLayout) {
            <ms-scroll-adapter [msScrollSelectedInView]="activeInterval && activeInterval.name" [scrollItems]="intervals" [buttonSize]="36">
                <ng-container *ngTemplateOutlet="ItemTemplate"></ng-container>
            </ms-scroll-adapter>
        } @else {
            <ng-container *ngTemplateOutlet="ItemTemplate"></ng-container>
        }
    </div>
}
<ng-template #ItemTemplate>
    @if (showTitle) {
        <div class="item-header col-12 quick-links">{{ title }}</div>
    }
    @for (interval of intervals; track interval.key; let i = $index) {
        <ms-item
            class="calendar-item col-12"
            [title]="interval.title"
            [icon]="interval.icon"
            [arrow]="false"
            [href]="interval.url"
            [class.active]="interval.active"
            [ngClass]="intervalClass"
            [attr.data-menu-item-id]="interval.name"
            [attribute]="interval.key"
            (itemClicked)="onItemClicked(interval, i)">
            @if (interval.date && layout === 'TilesCarousel') {
                <span item-title>{{ interval.date }}</span>
            }
        </ms-item>
    }
</ng-template>
